module.exports = __webpack_public_path__ + "static/media/YB5F18_2.e3ce232e.jpg";